import React from 'react';
import PropTypes from 'prop-types';

import {
	MInputField,
} from '../../molecules';

export default function OFaqSectionInfo({
	title,
	onTitleChange,

}) {
	return (
		<section className="o-product-detail-info">
			<MInputField
				id="faqTitle"
				label="Section titel"
				value={title}
				required
				onChange={onTitleChange}
			/>

		</section>
	);
}

OFaqSectionInfo.propTypes = {
	title: PropTypes.string,

	onTitleChange: PropTypes.func,
};

OFaqSectionInfo.defaultProps = {
	title: '',
	onTitleChange: undefined,
};




// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.faq-section-info.js